import { AccentBorder, Flex } from "@/common/styles";
import styled, { createGlobalStyle } from "styled-components";

export const CreateBookingContainer = styled(Flex)`
  flex-direction: column;
  height: 100%;
  .create-booking-spinner,
  .create-booking-inmate-container{
    min-height: ${({ headerHeight = 76 }) => `calc(100dvh - ${headerHeight}px - 66px)`};
  }
  /* height: 100%; */
`;

export const ActionHeader = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
`;

export const NotificationStyles = createGlobalStyle`
   .ant-notification {
    z-index: 100000 !important;
  }
`;
